import React from "react";
import Slide from "react-reveal/Slide";

const InventoryMonitorBusinessComp = () => {
  return (
    <section className="relative overflow-hidden bg-white py-24">

      {/* Decorative Background */}
      <div className="absolute -left-32 top-10 h-80 w-80 rounded-full bg-red-100 blur-[120px]" />
      <div className="absolute right-0 bottom-0 h-96 w-96 rounded-full bg-orange-100 blur-[140px]" />

      <div className="relative max-w-7xl mx-auto px-6">

        <div className="grid items-center gap-20 lg:grid-cols-2">

          {/* LEFT */}

          <Slide left>

            <div className="relative flex justify-center">

              {/* Image */}

              <img
                src={`${process.env.PUBLIC_URL}/images/site/monitor.png`}
                alt="Inventory Dashboard"
                className="relative z-10 w-full max-w-xl rounded-[32px] border border-gray-200 shadow-[0_30px_70px_rgba(0,0,0,.08)] transition duration-500 hover:-translate-y-2 hover:shadow-[0_40px_90px_rgba(0,0,0,.12)]"
              />

              {/* Floating Card */}

              <div className="absolute -left-8 top-10 rounded-3xl border border-gray-200 bg-white p-5 shadow-2xl">

                <p className="text-sm text-gray-500">
                  Inventory
                </p>

                <h3 className="mt-1 text-3xl font-black text-red-600">
                  18,540
                </h3>

                <p className="text-green-600 text-sm">
                  ▲ Live Stock
                </p>

              </div>

              {/* Floating Card */}

              <div className="absolute -right-6 bottom-10 rounded-3xl border border-gray-200 bg-white p-5 shadow-2xl">

                <p className="text-sm text-gray-500">
                  Sales Today
                </p>

                <h3 className="mt-1 text-3xl font-black text-red-600">
                  ₦4.2M
                </h3>

                <p className="text-orange-500 text-sm">
                  Updated Live
                </p>

              </div>

            </div>

          </Slide>

          {/* RIGHT */}

          <Slide right>

            <div>

              {/* Badge */}

              <div className="inline-flex items-center gap-2 rounded-full bg-red-50 px-5 py-2">

                <span className="h-2 w-2 rounded-full bg-red-500 animate-pulse" />

                <span className="text-sm font-semibold text-red-600">
                  Monitor Your Business 24/7
                </span>

              </div>

              {/* Heading */}

              <h2 className="mt-8 text-5xl font-black leading-tight text-slate-900">

                Stay Connected To

                <span className="block bg-gradient-to-r from-red-600 via-orange-500 to-yellow-500 bg-clip-text text-transparent">

                  Every Part Of Your Business

                </span>

              </h2>

              <p className="mt-8 text-lg leading-9 text-gray-600">

                Access your inventory, sales, purchases, warehouses, and
                financial reports anytime, anywhere. SupaRecords gives you
                complete visibility into your business with live dashboards,
                intelligent stock alerts, and detailed analytics that help you
                make faster and smarter decisions.

              </p>

              {/* Features */}

              <div className="mt-10 grid gap-5 sm:grid-cols-2">

                {[
                  "Real-time Inventory",
                  "Sales Monitoring",
                  "Purchase Tracking",
                  "Multi Warehouse",
                  "Low Stock Alerts",
                  "Cloud Access",
                ].map((item) => (

                  <div
                    key={item}
                    className="flex items-center gap-3 rounded-2xl bg-gray-50 p-4 transition hover:bg-red-50"
                  >
                    <div className="flex h-8 w-8 items-center justify-center rounded-full bg-red-100">

                      <span className="text-red-600 font-bold">
                        ✓
                      </span>

                    </div>

                    <span className="font-medium text-gray-700">
                      {item}
                    </span>

                  </div>

                ))}

              </div>

              {/* CTA */}

              <div className="mt-12 flex flex-wrap gap-5">

                <a
                  href="https://admin.suparecords.ng/auth/signup"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="rounded-2xl bg-gradient-to-r from-red-600 to-orange-500 px-10 py-5 font-semibold text-white shadow-xl transition duration-300 hover:scale-105 hover:shadow-red-300"
                >
                  Start Free Today →
                </a>

                <a
                  href="#pricing"
                  className="rounded-2xl border border-gray-300 px-10 py-5 font-semibold text-gray-700 transition hover:bg-gray-100"
                >
                  View Pricing
                </a>

              </div>

            </div>

          </Slide>

        </div>

      </div>

    </section>
  );
};

export default InventoryMonitorBusinessComp;